import React from "react";
import { Divider, useTheme } from "@mui/material";

import { useGetSpecificInventoryQuery } from "state/api";
import Loader from "components/Loader";
import AdditionalInfo from "./AdditionalInfo";
import { Toaster } from "react-hot-toast";
import ImageGalleryComponent from "./ImageGalleryComponent";
import StatusChangeButtons from "./StatusChangeButtons";
import DescriptionCard from "./DescriptionCard";
import { useSearchParams } from "react-router-dom";

const ProductPage = () => {
  // get id from search params
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const { data, isLoading } = useGetSpecificInventoryQuery(id);
  const theme = useTheme();
  return (
    <div>
      {isLoading ? (
        <Loader />
      ) : (
        <section
          className=" overflow-hidden"
          style={{
            color: theme.palette.primary[200],
          }}
        >
          <div className="container px-5 mx-auto">
            <div className="w-full mx-auto flex flex-wrap">
              <div className="image-gallery-container md:w-3/5 w-full object-cover object-center">
                <ImageGalleryComponent data={data} />
              </div>
              <DescriptionCard data={data} />
              <StatusChangeButtons data={data} />
            </div>

            <Divider
              sx={{
                width: "100%",
                height: "1px",
                backgroundColor: "gray",
                margin: "2rem 0",
              }}
            />
            <AdditionalInfo data={data} />
          </div>

          <Toaster
            position="top-right"
            reverseOrder={false}
            gutter={8}
            containerClassName=""
            containerStyle={{}}
            toastOptions={{
              // Define default options
              className: "",
              duration: 5000,
              style: {
                background: "#363636",
                color: "#fff",
              },

              // Default options for specific types
              success: {
                duration: 3000,
                theme: {
                  primary: "green",
                  secondary: "black",
                },
              },
            }}
          />
        </section>
      )}
    </div>
  );
};

export default ProductPage;
